module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 1
// module chunks = 0 1 2 3 4 5